import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getGallery } from "../Service/Api";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";

const Gallery = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const topperData = await getGallery();
      setData(topperData);
    };
    fetchData();
  }, []);

  useEffect(() => {
    console.log("events_data", data[0]);
  }, [data]);

  const emptyArray = [
    {
      title: "Gallery Title",
      day: "DD",
      month: "MM",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/gallery1.png",
      description: "Stay tuned for latest updates",
    },
    {
      title: "Gallery Title",
      day: "DD",
      month: "MM",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/gallery2.png",
      description: "Stay tuned for latest updates",
    },
    {
      title: "Gallery Title",
      day: "DD",
      month: "MM",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/gallery3.png",
      description: "Stay tuned for latest updates",
    },
    {
      title: "Gallery Title",
      day: "DD",
      month: "MM",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/gallery3.png",
      description: "Stay tuned for latest updates",
    },
  ];

  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="row">
        <Slider {...settings}>
          {data?.length > 0 ? (
            data
              ?.filter((div) => div.category === "PhotoGallery")
              .map((item, index) => (
                <div className="item" key={index}>
                  <Link to={`/SubGallery?id=${item._id}`}>
                    <div className="galleryimg">
                      <div className="galleryimgbox">
                        <LazyLoad>
                          {" "}
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                            className="img-fluid"
                            alt="Carmel Convent School, dharuhera"
                          />
                        </LazyLoad>
                        <div className="gallerydesc">
                          <h6>{item.title}</h6>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
          ) : (
            <div className="item">
              <div className="galleryimg">
                <div className="galleryimgbox">
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/demo.jpg"
                      className="img-fluid"
                      alt="Carmel Convent School, dharuhera"
                    />
                  </LazyLoad>
                  <div className="gallerydesc">
                    <h6>Gallery Title</h6>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Slider>
      </div>
    </>
  );
};

export default Gallery;
